import Glide from "@glidejs/glide";

const benefitSlider = () => {
    if(document.querySelector('.glide-mobile')){
        const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        if(vw < 993){
            new Glide('.glide-mobile', {
                type: 'slider',
                startAt: 0,
                perView: 3.5,
                gap: 6,
                rewind: false,
                breakpoints:{
                    769:{
                        perView: 2.15
                    },
                    500:{
                        perView: 1.15
                    }
                }
            }).mount()
        }
    }
}
export default  benefitSlider;